module.exports = "/images/eye-red.svg?1694436f23ee6e6d3b04c3c350d09da9";